export const featureName = 'setting_genaral_configuration';